import { Formik, Form, FieldArray, Field } from "formik";
import Dropdown from "components/Dropdown";
import FormWrapper from "components/FormWrapper";
import ResetAndSubmit from "components/ResetAndSubmit";
import * as Yup from "yup";
import { Img } from "components";
import OccasionCard from "components/NewCards/OccasionCard";
import axios from "axios";
import { useEffect, useState } from "react";
import { useGlobalState } from "state";
import { showGlobalModal } from "components/GlobalModal";
import { API_CONSTANT_ONBOARDING } from "utils";

const validationSchema = Yup.object({
    filter: Yup.string().notRequired(),
    searchTerm: Yup.string().notRequired(),
    occasions: Yup.array()
        .test(
            "at-least-one-selected",
            "At least one festival must be selected",
            (value) => value && value.some((item) => item.IS_OPTED)
        )
});

const getUniqueTypes = (data) => [...new Set(data.map(item => item.TYPE))].map(type => ({ name: type, value: type, label: type }));

const Occasions = ({ handleNavigate, resetFormData, disableForm }: { handleNavigate, resetFormData?: any, titleAndDesNotRequired?: boolean, disableForm?: boolean }) => {

    const [festivals, setFestivals] = useState([]);
    const [loader, setLoader] = useState(false);
    const { instData } = useGlobalState();

    const categories: any = getUniqueTypes(festivals) || [];

    const fetchData = async () => {
        try {
            setLoader(true);
            const response = await axios.get(`${API_CONSTANT_ONBOARDING}/master/masterEvent/list?event_type=EVENT,FESTIVAL`);
            setFestivals(festivals => (response?.data?.data?.["Master Events"] || response?.data?.data));
        } catch (err) { } finally {
            setLoader(false);
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    const loadInitialData = () => {
        const savedData = JSON.parse(sessionStorage.getItem("occasions")) || [];
        return savedData.length ? savedData : festivals;
    };

    return !loader ? <Formik
        initialValues={{ filter: "", searchTerm: "", occasions: loadInitialData() }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={async (values) => {
            try {
                setLoader(true)
                sessionStorage.setItem("occasions", JSON.stringify(values.occasions));
                const payload = {
                    "BRANCH_ID": instData?.BRANCH_ID,
                    "ACADEMIC_YEAR_ID": instData?.ACADEMIC_YEAR_ID,
                    "OPTED_EVENTS": values.occasions?.filter(item => item?.IS_OPTED)?.map(item => ({
                        "MASTER_EVENT_ID": item?.MASTER_EVENT_ID,
                        "EVENT_NAME": item?.TITLE,
                        "EVENT_DATE": item?.START_DATE,
                        "EVENT_BANNER": item?.BannerUrl,
                        "EVENT_TYPE": item?.TYPE
                    }))
                }
                const response = await axios.post(`${API_CONSTANT_ONBOARDING}/comm/branchEventOnboarding/sync`, payload, {
                    headers: {
                        database: instData?.DATABASE_NAME,
                        "institute-id": instData?.INSTITUTE_ID,
                    }
                });
                if ([200, 201].includes(+response?.data?.code)) {
                    handleNavigate();
                } else {
                    showGlobalModal(response?.data?.message, "warning")
                }
            } catch (err) {
                showGlobalModal(err.message, "error")
            } finally {
                setLoader(false);
            }
        }}
    >
        {({ values, handleSubmit, resetForm, errors, setFieldValue }) => {

            const handleCheckboxChange = (index) => {
                setFieldValue(
                    `occasions[${index}].IS_OPTED`,
                    !values.occasions[index].IS_OPTED
                );
            };

            const filteredOccasions = (values.searchTerm
                ? values?.occasions?.filter((option) =>
                    option?.TITLE.toLowerCase().includes(values.searchTerm.toLowerCase())
                )
                : values.occasions)?.filter((option) =>
                    option?.TITLE.toLowerCase().includes(values.searchTerm?.toLowerCase() || "")
                )
                .filter((option) =>
                    !!values.filter ? option.TYPE === values.filter : true
                );

            const allSelected = filteredOccasions?.every((opt) => opt.IS_OPTED);

            const handleSelectAll = () => {
                const newChecked = !allSelected;
                setFieldValue(
                    "occasions",
                    values?.occasions?.map((opt) => ({ ...opt, IS_OPTED: newChecked }))
                );
            };

            return <FormWrapper
                title={"Let the Festival Begin!"}
                description={"Let us help you make every festival and event special! Share the festivals you wish to celebrate with your institution."}
                childern={<Form onSubmit={handleSubmit}>
                    <div>
                        <div className="rounded-2xl my-1">
                            <FieldArray name="occasions">
                                {({ push, remove, form }) => (
                                    <div className="grid grid-cols-6 gap-4">
                                        <div className="col-span-6">
                                            <div className="flex justify-between items-center gap-4">
                                                <div className="w-[70%] rounded-xl bg-gray-100 flex gap-2 p-2 h-[7vh]">
                                                    <Img src={"/images/search.svg"} />
                                                    <Field
                                                        type="text"
                                                        name="searchTerm"
                                                        className="w-[99%] p-2 text-[2vh]"
                                                        placeholder="Search for occasions"
                                                    />
                                                </div>
                                                <div className="w-[30%] flex items-center gap-4">
                                                    <div className="w-[70%]">
                                                        <Dropdown
                                                            disable={disableForm}
                                                            name={`filter`}
                                                            placeHolder="Apply Filter"
                                                            options={categories}
                                                            customHeight="h-auto"
                                                            leftIcon="/images/filter.svg"
                                                        />
                                                    </div>
                                                    <div className="w-[30%]">
                                                        <label className="text-[2.2vh] flex gap-2 items-center">
                                                            <input
                                                                type="checkbox"
                                                                onChange={handleSelectAll}
                                                                checked={allSelected}
                                                                className="p-[2vh] rounded-md border border-solid"
                                                            />
                                                            Select All
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {filteredOccasions.map((option, index) => <OccasionCard key={"asdasdasdasdOssccasions" + index} element={option} name={`occasions[${index}].IS_OPTED`} onChange={() => handleCheckboxChange(index)} />)}
                                    </div>)}
                            </FieldArray>
                        </div>
                    </div>
                    {!disableForm && <div className="flex justify-end my-2">
                        {loader ? (
                            <Img
                                src={"/images/loader.gif"}
                                className="w-10 h-10"
                                alt="Loading"
                            />
                        ) : (
                            <ResetAndSubmit
                                submitToolTip={Boolean(errors?.occasions) && "At least one occasion must be selected"}
                                isError={Boolean(errors?.occasions)}
                                resetForm={() => {
                                    resetForm();
                                    resetFormData();
                                }}
                            />
                        )}
                    </div>}
                </Form>}
            />
        }}
    </Formik> : <div className="flex justify-center"><Img src={"/images/loader.gif"} className="h-20" /></div>
};

export default Occasions;
